import i18n from 'i18next';

const getBoolToYesOrNot = (param: boolean) => (param ? i18n.t('term.yes') : i18n.t('term.no'));

export { getBoolToYesOrNot };
